<template>
  <div class="row">
    <div class="col-12 header">
      <div class="custom_nav container">
        <div class="toggle-wrap" @click="toggleMenu(this)">
          <i class="fas fa-ellipsis-v"></i>
        </div>
        <div class="text-center">
          <img src="@/assets/images/avatar.svg" alt="avatar.svg" class="cursor_pointer" data-toggle="modal"
            data-target="#newsletter">
          <p class="text-white">Subscribe to our Newsletter</p>
        </div>
      </div>

      <newsletter></newsletter>

    </div>
  </div>
</template>

<script>
import User from '@/models/User'
import Newsletter from './Newsletter.vue'
export default {
  name: 'Navbar',
  components: { Newsletter },
  data () {
    return {
      user: new User(this.$store.getters.user)
    }
  },
  mounted () {
    $(window).scroll(function () {
      if (window.scrollY < 50) {
        $('.custom_nav').removeClass('scrolled')
      }
    });
    (function () {
      var doc = document.documentElement
      var w = window

      var prevScroll = w.scrollY || doc.scrollTop
      var curScroll
      var direction = 0
      var prevDirection = 0

      var header = $('.custom_nav')

      var checkScroll = function () {
        curScroll = w.scrollY || doc.scrollTop
        if (curScroll > prevScroll) {
          // scrolled up
          direction = 2
        } else if (curScroll < prevScroll) {
          // scrolled down
          direction = 1
        }

        if (direction !== prevDirection) {
          toggleHeader(direction, curScroll)
        }

        prevScroll = curScroll
      }

      var toggleHeader = function (direction, curScroll) {
        if (direction === 2 && curScroll > 50) {
          header.addClass('hide')
          prevDirection = direction
        } else if (direction === 1) {
          header.removeClass('hide')
          header.addClass('scrolled')
          prevDirection = direction
        }
      }

      window.addEventListener('scroll', checkScroll)
    })()
  },
  methods: {
    toggleMenu (e) {
      $('.toggle-wrap').toggleClass('active')
      document.querySelector('aside').classList.toggle('active')
      if (!$('.toggle-wrap').hasClass('active')) {
        $('.toggle-wrap').html('<i class="fas fa-ellipsis-v"></i>')
      } else {
        $('.toggle-wrap').html('<i class="fas fa-times" style="font-size:20px"></i>')
      }
      // e.innerHTML = '<i class="fas fa-ellipsis-v"></i>'
    }
  }
}

</script>

<style scoped>
  .modal .modal-content:before {
    /* content: ''; */
    background-image: url('../assets/images/popup-bg.png');
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    opacity: 0.08;
  }

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue